import { useTranslation as useReactI18nextTranslation } from 'react-i18next';
import i18n from './instance';
/**
 * Hook de traducao para componentes React.
 *
 * Envolve o useTranslation do react-i18next (que garante re-render ao trocar de
 * idioma) e expoe um `t` com chaves tipadas. `i18n` continua acessivel para
 * casos como changeLanguage() ou leitura de i18n.language.
 */
export function useTranslation() {
    var _a = useReactI18nextTranslation(), t = _a.t, i18nInstance = _a.i18n;
    var typedT = function (key, options) { return t(key, options); };
    return { t: typedT, i18n: i18nInstance };
}
/**
 * Versao standalone (fora de componentes React) da funcao de traducao.
 * Util em handlers, services ou utilitarios. Nao dispara re-render.
 */
export var t = function (key, options) { return i18n.t(key, options); };
export default useTranslation;
